/* eslint-disable no-undef */
// import { LocalStorage } from 'quasar'
// import axios from 'axios'
import Carregando from 'src/components/Carregando/Carregando.vue'
import NotificacaoMixin from 'src/core/mixin/NotificacaoMixin'
import usuarioLoginStore from 'src/store/usuario-login/'

export default {
  name: 'LayoutSite',
  components: { Carregando },
  mixins: [NotificacaoMixin],
  meta () {
    return {
      meta: [
        { 'name': 'robots', 'content': 'noindex' }
      ]
    }
  },
  data () {
    return {
      barraFiltros: true,
      tituloPage: null,
      fotoPerfil: 'avatar.jpg',
      menus: [
        { nome: 'Veiculações', url: 'anuncios.grid' },
        // { nome: 'Veículos', url: 'bens.grid' },
        { nome: 'Usuários', url: 'clientes.grid' },
        { nome: 'Conteúdos', url: 'conteudos.grid' },
        { nome: 'Locais', url: 'locais.grid' },
        { nome: 'Grupos de categorias', url: 'grupos-categorias.grid' },
        { nome: 'Categorias', url: 'categorias.grid' },
        { nome: 'Carrocerias', url: 'carrocerias.grid' },
        { nome: 'Cores', url: 'cores.grid' },
        { nome: 'Combustíveis', url: 'combustiveis.grid' },
        { nome: 'Câmbios', url: 'cambios.grid' },
        { nome: 'Grupos de acessórios', url: 'grupos-acessorios.grid' },
        { nome: 'Acessórios', url: 'acessorios.grid' },
        { nome: 'Marcas', url: 'marcas.grid' },
        { nome: 'Modelos', url: 'modelos.grid' },
        { nome: 'Versões', url: 'versoes.grid' },
        { nome: 'Tags', url: 'tags.grid' },
        { nome: 'Proposta', url: 'credere/propostas.grid' },
        { nome: 'Mídias', url: 'midias.grid' },
        { nome: 'Grupos de verificações', url: 'grupos-verificacoes.grid' },
        { nome: 'Verificações', url: 'verificacoes.grid' },
        { nome: 'Situações Laudo', url: 'situacoes-laudos.grid' },
        { nome: 'Laudos de Vistoria', url: 'laudos.grid' }
      ],

      carregando: false,
      iconeMenu: 'app:menu',
      forcerRender: 50
    }
  },
  beforeCreate () {
    if (!this.$store.hasModule('usuario-login')) this.$store.registerModule('usuario-login', usuarioLoginStore)
  },
  computed: {
    classeBtnToggle () {
      let classe = 'btn-toggle-lista'
      if (this.barraFiltros) {
        classe += ' ativo '
      }
      return classe
    },
    logado () {
      return this.$store.getters['usuario-login/get']
    },
    vendedorAtivo () {
      const rolesUsuario = this.logado && this.logado.roles ? this.logado.roles.map(role => role.name) : []
      return rolesUsuario.includes('Vendedor')
    }
  },
  mounted () {
    if (this.$q.screen.width < 820) {
      this.barraFiltros = false
    } else {
      this.barraFiltros = true
    }
    this.$store.dispatch('usuario-login/checarLoginAdmin')
    if (this.logado && this.logado.foto_url_completa) {
      this.fotoPerfil = this.logado.foto_url_completa
      this.forcerRender++
    }
  // this.validarLogado()
  },
  watch: {
    '$q.screen.width':
  {
    handler (agora) {
      if (agora < 820) {
        this.barraFiltros = false
      } else {
        this.barraFiltros = true
      }
    }
  },
    '$route.name' () {
      this.validarLogado()
    }
  },
  methods: {
    validarLogado () {
      if (this.logado) {
      // const temPermissao = this.rotasQueTemPermissao.findIndex(e => e.name === this.$route.name)
      // if (temPermissao < 0) {
      //   this.notificacao('aviso', 'Você não tem permissão de acessar essa página!', 10000)
      //   this.$router.push({ name: 'homesite' })
      // }
      } else {
      // Deslogado
        this.notificacao('aviso', 'Você esta deslogado!', 7000)
        this.irRota({ name: 'login-admin' })
      }
    },

    irRota (rota) {
      this.$router.push(rota)
    // let routeData = this.$router.resolve(rota)
    // window.location.href = routeData.href
    }
  }
}
